import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueMeta from "vue-meta";
import "fullpage.js/vendors/fullpage.parallax.min";
import VueFullPage from "vue-fullpage.js";
import store from "./store";
import Vue2TouchEvents from "vue2-touch-events";

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(VueFullPage);
Vue.use(Vue2TouchEvents);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
